import React from 'react'

const CreateNewSession = () => {
  return (
    <div>CreateNewSession</div>
  )
}

export default CreateNewSession